const STORAGE_KEY = 'unrollme.utm'

const UTM_FIELDS = {
  source: 'utm_source',
  medium: 'utm_medium',
  campaign: 'utm_campaign',
  term: 'utm_term',
  content: 'utm_content',
}

const APP_REDIRECT_PATHS = ['/a/', '/app/inbox']

const hasWindow = () => typeof window !== 'undefined'

export const extractUtmParamsFromSearch = search => {
  const params = new URLSearchParams(search || '')

  return Object.keys(UTM_FIELDS).reduce((captured, field) => {
    const value = params.get(UTM_FIELDS[field])

    if (value) {
      captured[field] = value
    }

    return captured
  }, {})
}

export const captureUtmParams = (search = hasWindow() ? window.location.search : '') => {
  if (!hasWindow()) {
    return {}
  }

  const captured = extractUtmParamsFromSearch(search)

  if (Object.keys(captured).length > 0) {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(captured))
  }

  return captured
}

export const getCapturedUtmParams = () => {
  if (!hasWindow()) {
    return {}
  }

  try {
    const storedParams = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}')
    return storedParams
  } catch (error) {
    return {}
  }
}

export const clearCapturedUtmParams = () => {
  if (!hasWindow()) {
    return
  }

  window.sessionStorage.removeItem(STORAGE_KEY)
}

const shouldAppendUtmParams = targetPathname =>
  APP_REDIRECT_PATHS.some(path => targetPathname === path || targetPathname.startsWith(path))

export const appendUtmParams = url => {
  if (!hasWindow() || !url) {
    return url
  }

  const captured = getCapturedUtmParams()
  if (Object.keys(captured).length === 0) {
    return url
  }

  const targetUrl = new URL(url, window.location.origin)
  if (!shouldAppendUtmParams(targetUrl.pathname)) {
    return url
  }

  Object.keys(captured).forEach(field => {
    targetUrl.searchParams.set(UTM_FIELDS[field], captured[field])
  })

  return targetUrl.pathname + targetUrl.search + targetUrl.hash
}
